import type {CollectionSubType} from 'domainTypes';
import {CollectionSubTypes} from 'domainTypes';
import type {DataValue, VerifiedLinkedCatalogPostLink} from '../types';
import {isVerifiedLinkedCatalogPostLink} from './isVerifiedLinkedCatalogPostLink';

export const isVerifiedLinkedCollectionLink = (
  link: DataValue | undefined,
): link is VerifiedLinkedCatalogPostLink =>
  isVerifiedLinkedCatalogPostLink(link) &&
  CollectionSubTypes.includes(link.type as CollectionSubType);
